export const industryChoices = [
  { id: 'real_estate', name: 'Immobilier' },
  { id: 'law', name: 'Avocats' },
  { id: 'ecommerce', name: 'Ecommerce' },
  { id: 'wellness', name: 'Bien-être' },
  { id: 'telecom', name: 'Télécom' },
  { id: 'accounting', name: 'Comptabilité' },
  { id: 'construction', name: 'Construction' },
  { id: 'healthcare', name: 'Santé' },
  { id: 'education', name: 'Éducation' },
  { id: 'finance', name: 'Finance/Banque' },
  { id: 'insurance', name: 'Assurances' },
  { id: 'consulting', name: 'Consulting/Conseil' },
  { id: 'technology', name: 'Tech/IT' },
  { id: 'hospitality', name: 'Restauration/Hôtellerie' },
  { id: 'retail', name: 'Retail/Commerce' },
  { id: 'transport', name: 'Transport/Logistique' },
  { id: 'manufacturing', name: 'Industrie manufacturière' },
  { id: 'hr', name: 'RH' },
  { id: 'marketing', name: 'Marketing/Publicité' },
  { id: 'automotive', name: 'Automobile' },
  { id: 'beauty', name: 'Beauté/Cosmétiques' },
  { id: 'food', name: 'Alimentation/Agroalimentaire' },
  { id: 'tourism', name: 'Tourisme' },
  { id: 'agriculture', name: 'Agriculture' },
  { id: 'energy', name: 'Énergie' },
  { id: 'media', name: 'Médias/Communication' },
  { id: 'services', name: 'Services' },
  { id: 'government', name: 'Secteur public' },
  { id: 'nonprofit', name: 'Associations/ONG' },
  { id: 'other', name: 'Autres' },
]
